<mg-table [collectionComponent]="this" matSort stickyHeaders>

  <ng-container matColumnDef="groep">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Groep </th>
    <td mat-cell *matCellDef="let row"> {{getGroep(row.groep)}} </td>
  </ng-container>

  <ng-container matColumnDef="rubriek">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Rubriek </th>
    <td mat-cell *matCellDef="let row"> {{row.rubriekID?.omschr}} </td>
  </ng-container>

  <ng-container matColumnDef="soortID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Soort </th>
    <td mat-cell *matCellDef="let row"> {{row.soortID?.omschrijving}} </td>
  </ng-container>

  <ng-container matColumnDef="merkID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Merk </th>
    <td mat-cell *matCellDef="let row"> {{row.merkID?.omschrijving}} </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
    <td mat-cell *matCellDef="let row"> {{row.type}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsStd">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Std (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsStd?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsCY">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs CIJ (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsCY?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsRvA">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs RvA (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsRvA?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsBRL100">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs BRL100 (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsBrl100?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsNen">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs NEN (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsNen?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsKeuring">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Keuring (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsKeuring?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsCrossCheck">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs CrossCheck (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsCrossCheck?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsScios">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Scios (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsScios?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsBRL6010">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs BRL6010 (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsBRL6010?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsPool">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Pool Binnen (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsPool?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsKwestie">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Kwestie Binnen (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsKwestie?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsPoolBuiten">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Pool Buiten (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsPoolBuiten?.toFixed(2)}} </td>
  </ng-container>

  <ng-container matColumnDef="PrijsKwestieBuiten">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Kwestie Buiten (€)</th>
    <td mat-cell *matCellDef="let row">{{row.prijsKwestieBuiten?.toFixed(2)}} </td>
  </ng-container>

</mg-table>
